<template>
  <FormContainer without-divider>
    <template #content>
      <div class="form__bloc">
        <WrapperInput
          v-bind:model-value="model?.contrat?.codeDrf"
          label="N° DRF"
          class="col-12 col-md-12 col-sm-36"
          disabled
        />
        <WrapperInput
          v-bind:model-value="model?.drf?.contrat?.referenceProjet"
          label="N° référence projet"
          class="col-12 col-md-12 col-sm-36"
          disabled
        />
        <WrapperInputNumber
          v-bind:model-value="model?.drf?.contrat?.nombreContrats ?? null"
          label="Nombres de contrats"
          class="col-12 col-md-12 col-sm-36"
          disabled
          :decimal="0"
        />
      </div>
      <div class="form__bloc">
        <WrapperInput
          v-bind:model-value="model?.drf?.formation?.intitule"
          label="Intitulé de la formation"
          class="col-24 col-sm-36"
          disabled
        />
        <WrapperInputNumber
          v-bind:model-value="dureeTotale"
          label="Durée de la formation"
          class="col-12 col-sm-36"
          help="Durée totale saisie, bilans y compris si présents"
          disabled
        />
      </div>
      <div class="form__bloc">
        <WrapperInputDate
          v-bind:model-value="model?.drf?.dateDepotDrf"
          label="Date dépôt"
          class="col-12 col-md-12 col-sm-36"
          disabled
        />
        <WrapperInputDate
          v-bind:model-value="model?.drf?.dateFinValiditeDrf"
          label="Date de fin de validité"
          class="col-12 col-md-12 col-sm-36"
          :alertLabel="meta.drf?.dateFinValiditeDrf?.$messageErreurDirty"
          disabled
        />
        <WrapperInput
          v-bind:model-value="StatutLibelle[model?.drf?.statut!]"
          label="Statut"
          class="col-12 col-md-12 col-sm-36"
          :alertLabel="meta.drf?.statut?.$messageErreurDirty"
          disabled
        />
      </div>
    </template>
  </FormContainer>
  <!--
  <FormContainer >
    <template #content>

      <CourriersList
      :courriers="model?.drf?.courriers ?? []"
      :code="model?.contrat?.codeDrf!"
      endpoint="reservationsfonds"
    />

    </template>
  </FormContainer>
 -->
</template>

<script setup lang="ts">
  import { StatutLibelle } from '@/features/domaine/types/opco/Reservations-fonds/Dossier/Statut'
  import { DEMANDE_STORE, FormContainer } from '@/features/interface/demande/shared'
  import { storeToRefs } from 'pinia'
  import { computed, inject } from 'vue'

  const store = inject(DEMANDE_STORE)!.getStore<'MODEL_CXPI'>()
  const { model, meta } = storeToRefs(store)

  const dureeTotale = computed(() => {
    return (model?.value?.drf?.formation?.dureeTotale || 0) + (model?.value?.drf?.formation?.dureeTotaleBilans || 0)
  })
</script>
